import React from "react";
import { Fragment } from "react";
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import { Font } from "@react-pdf/renderer";
import IRANSans from '../../../fonts/IRANSans.ttf';
Font.register({ family: "IRANSans", src: IRANSans });

const styles = StyleSheet.create({
    page: {width:300,fontSize: 11,paddingTop: 10,paddingLeft: 20,paddingRight: 20,lineHeight: 1.5,flexDirection: 'column', fontFamily:'IRANSans', color:'#116466' },

    spaceBetween : {flex : 1,flexDirection: 'row',alignItems:'center',justifyContent:'space-between',color: "#3E3E3E" },

    titleContainer: {flexDirection: 'row',marginTop: 24},
    
    logo: { width: 90 },

    reportTitle: { textAlign: 'center' },

    addressTitle : {}, 
    
    
    number : {}, 
    
    address : { },
    
    theader : {marginTop : 20,paddingTop: 4 ,paddingLeft: 7 ,flex:1,height:20, backgroundColor : '#DEDEDE',borderColor : '#D9B08C',borderWidth:1, textAlign:'center'},

    theader2 : { flex:2, borderWidth:1},

    tbody:{ paddingTop: 4 , paddingLeft: 7 , flex:1, borderColor : '#D9B08C', borderWidth:1, borderWidth:1, textAlign:'center'},
    tbody2:{ flex:2, borderWidth:1, }
    
});


// const sendAddress = () => (
//     <View style={styles.address}>
//         <text>hiii</text>
//     </View>
// );


// const receiverAddress = () => (
//     <View style={styles.address}>
        
//     </View>
// );

// const journalNumber = () => (
//     <View style={styles.number}>
        
//     </View>
// );

// const receiverName = () => (
//     <View style={styles.titleContainer}>
        
//     </View>
// );

// const receiverPhone = () => (
//     <View style={styles.number}>
        
//     </View>
// );



    const TableHead = () => (
        
        <View style={{ width:'100%', flexDirection :'row', marginTop:10, direction:'rtl'}}>
             {/* <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>شغل</Text>   
            </View> */}
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>موجودی</Text>   
            </View>
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>موجودی-ماه</Text>   
            </View> 
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>تحصیلات</Text>   
            </View> 
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>محل زندگی</Text>   
            </View>
            
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>منزل</Text>   
            </View>
            <View style={styles.tbody}>
                <Text style={{direction:'rtl'}} >همراه</Text>   
            </View>
            <View style={[styles.tbody]}>
                <Text style={{direction:'rtl', marginRight:'2%'}} >نام خانوادگی</Text>   
            </View>
            <View style={styles.tbody } >
                <Text style={{direction:'rtl'}}>نام</Text>   
            </View>
            
       
    </View>
    );

    const TableBody = (props) => (
        props.printData.map((receipt)=>{
            return(

                <Fragment key={receipt.person.personID}>
                <View style={{ width:'100%', flexDirection :'row'}}>
                    {/* <View style={[styles.tbody]}>
                        <Text style={{direction:'rtl'}} >{ ""+receipt.person.job}</Text>   
                    </View> */}
                    <View style={[styles.tbody]}>
                        <Text style={{direction:'rtl'}} >{ ""+receipt.remainAmount}</Text>   
                    </View>
                    <View style={[styles.tbody]}>
                        <Text style={{direction:'rtl'}} >{ ""+receipt.remainMonth}</Text>   
                    </View>
                    <View style={[styles.tbody]}>
                        <Text style={{direction:'rtl'}} >{ ""+receipt.person.degree == null ? "---":receipt.person.degree}</Text>   
                    </View> 
                    <View style={[styles.tbody]}>
                        <Text style={{direction:'rtl'}} >{ ""+receipt.person.city.cityName}</Text>   
                    </View>
                    {/* <View style={[styles.tbody]}>
                        <Text style={{direction:'rtl'}} >{ ""+receipt.person.city.province.provinceName}</Text>   
                    </View> */}
                    <View style={[styles.tbody]}>
                        <Text style={{direction:'rtl'}} >{ ""+receipt.person.homeNumber == null ? "---": receipt.person.homeNumber}</Text>   
                    </View>
                    <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>{"" + receipt.person.phoneNumber}</Text>   
                    </View>
                    <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>{receipt.person.lastName}</Text>   
                    </View>
                    <View style={styles.tbody}>
                       <Text style={{direction:'rtl'}}>{ receipt.person.firstName} </Text>   
                    </View>
                </View>
            </Fragment>

            )
            
           })
    );

   
   
    

const Pdf_Report_All_Subscript = (props)=>
{   
    
        return(    
            <Document style={{padding:"5%", direction:"rtl"}}>
                <Page  style={styles.page}>              
                    <TableHead/>
                    <TableBody printData = {props.printData}/>
                    
                </Page>
            </Document>
        )
   
    
    
}

export default Pdf_Report_All_Subscript;
